import axios from 'axios';
import type {
  ContactType,
  IContact,
  IContactCreateRequest,
  IContactCreateResponse,
} from '@bb/contacts';

import type { ContactPayload } from './types';

const createContact = async <T extends IContact>(
  type: ContactType,
  payload: ContactPayload<T>,
) => {
  const config: IContactCreateRequest = {
    url: '/contacts',
    data: {
      ...payload,
      type,
    },
    method: 'post',
  };

  const { data } = await axios.request<IContactCreateResponse>(config);

  return data;
};

export default createContact;
